<template>
  <Head title="Playbook Builder" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <play-builder></play-builder>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';
import { usePlaybookStore } from '../../stores/playbook';
import { useClientStore } from '../../stores/client';

const props = defineProps({
  client: Object,
  playbook: Object,
  audiences: Array,
  exports: Array,
  tab: {
    type: String,
    default: null
  },
  concepts: Array,
  asset_types: Array
});

// Set window globals immediately for legacy component compatibility
window.__CLIENT__ = props.client;
window.__PLAYBOOK__ = {
  playbook_selected: props.playbook,
  available_audiences: props.audiences,
  exports: props.exports,
  initial_tab: props.tab,
  concepts: props.concepts,
  asset_types: props.asset_types
};

// Also initialize stores directly
const playbookStore = usePlaybookStore();
const clientStore = useClientStore();

clientStore.setClient(props.client);
playbookStore.initialize(window.__PLAYBOOK__);
</script>

